import * as React from "react"
import PrimaryButton from "../components/PrimaryButton"
import { addMessage } from "../components/MessageContainer"
import getStepConfig from "./stepConfig"
import { dispatch } from "../store"
import { appActions, userInfoActions } from "../actions"
import api from "../utils/api"
import { useSelector } from "react-redux"
import * as AppTypes from "AppTypes"
import CheckBoxInput from "../components/CheckBoxInput"
import { updateLanguageAATagging, updateAATagging } from "../utils/aatagging"
import { redirectToCommonError } from "../utils/apiErrorHandler"
import DOMPurify from "dompurify"

const Declaration: React.FC = () => {

    const { isAppUpdated, userInfo, agreeMarketing, lang, langPack, tncData, isCallingApi } = useSelector((store: AppTypes.ReducerState) => ({
        isCallingApi: store.app.isCallingApi,
        isAppUpdated: store.app.isAppUpdated,
        userInfo: store.userInfo,
        lang: store.userInfo.lang,
        agreeMarketing: store.userInfo.agreeMarketing,
        langPack: store.config.langPack,
        tncData: store.config.tncData
    }))

    const [warning, setWarning] = React.useState({ consent1: false })

    const toggleAgreeMarketing = () => dispatch(userInfoActions.updateUserInfo({ agreeMarketing: !agreeMarketing }))
    const toggleConsent = (consent: "consent1" | "consent2") => {
        setWarning(Object.assign({}, warning, { [consent]: false }))
        dispatch(userInfoActions.updateUserInfo({ [consent]: !userInfo[consent] }))
    }

    const thaiConsent = (
        <React.Fragment key={"thaiConsents"}>
            <CheckBoxInput
                checked={userInfo["consent1"]}
                content={langPack["declarationConsent1"]}
                onClick={() => toggleConsent("consent1")}
                style={{ marginBottom: 20 }}
                warning={warning["consent1"]}
            />

            <CheckBoxInput
                checked={userInfo["consent2"]}
                content={langPack["declarationConsent2"]}
                onClick={() => toggleConsent("consent2")}
                style={{ marginBottom: 20 }}
                optional={langPack['optional']}
            />
        </React.Fragment>
    )

    const nextStepHandler = async () => {
        if (userInfo.activeCountry === "TH") {
            let allChecked = true
            if (!userInfo.consent1) {
                warning.consent1 = true
                allChecked = false
            }
            setWarning(Object.assign({}, warning))

            if (!allChecked) return

        }

        if (isAppUpdated) {

            const isConfirm = await addMessage({
                text: langPack["submitConfirmation"],
                buttons: {
                    confirm: langPack["buttonConfirm"],
                    cancel: langPack["buttonBack"]
                }
            })

            if (isConfirm) {
                const response = await api.submitApplication(userInfo)
                if (response && response.status === 200) {
                    if (response.data.appId && response.data.appId !== "") {
                        const { nextStep } = getStepConfig()
                        dispatch(appActions.setApplicationUpdated(false));
                        dispatch(appActions.gotoStep(nextStep))

                        // AA Tracking
                        const AALang = updateLanguageAATagging(langPack["lang"])
                        updateAATagging({
                            "event_name": "generic_form_complete_step9",
                            "form_name": "UOB PoY",
                            "step_name": "terms_and_conditions",
                            "language": AALang,
                            "country": userInfo.activeCountry.toLowerCase()
                        }, "other_form_step")
                    }
                    else {
                        const responseText = response.data.toString()
                        redirectToCommonError("Our team is working hard to fix this." + responseText)
                    }
                }
            } else {
                const { prevStep } = getStepConfig()
                dispatch(appActions.gotoStep(prevStep))
            }
        }
        else {
            await addMessage({
                title: langPack["labelError"],
                text: langPack["submitValidation"],
                buttons: {
                    confirm: langPack["buttonOk"],
                }
            })
        }
    }

    return (
        <>
            <div className="declaration-page">
                <div className="declaration-page__title">{langPack["headerTnC"]}</div>
                <div className="declaration-page__content">
                    <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(tncData[lang]) }}></p>
                </div>
            </div>
            <div className="declaration-consents">
                {userInfo.activeCountry === "TH" && thaiConsent}

                <CheckBoxInput
                    checked={agreeMarketing}
                    content={langPack["checkboxText"]}
                    onClick={toggleAgreeMarketing}
                    style={{ alignItems: 'center' }}
                    optional={langPack['optional']}
                />
            </div>
            {/* DO NOT DELETE THIS COMMENTED CODE */}
            {/* <div className="declaration-link">
                {langPack["pleaseReadOur"]}&nbsp;<a href={`tnc/tnc-${userInfo.activeCountry}.pdf`} target="_blank">{langPack["headerTnC"]}</a>
            </div> */}
            <div className="action">
                {langPack["competitionDisclaimer"] &&
                    <>
                        <p className="app-disclaimer">{langPack["competitionDisclaimerText"]}</p>
                        <br />
                    </>
                }
                <PrimaryButton
                    text={langPack["buttonTnC"]}
                    onClick={nextStepHandler}
                    disabled={isCallingApi}
                />
            </div>
        </>
    )
}

export default Declaration